<template lang="pug">
	content-page(pagenav-icon="tune" )
		div(slot="nav")
			areas-filter-list(v-model="filterstring" :show-map-button="!showMap" @map-button-click="showMap = true")
			navigation-default-list
			template(v-if="$i18n.locale !== 'de-DE'")
				.font-weight-bold.subtitle-1 {{$t('page.localdestinations:nav.locations')}}
				ul.list-unstyled
					li
						nuxt-link(:to="localePath({ name: 'localdestinations'})") {{$t('page.localdestinations:nav.overview')}}
					li
						nuxt-link(:to="localePath({ name: 'localdestinations-skihalls'})") {{$t('page.localdestinations:nav.skihalls')}}
					li
						nuxt-link(:to="localePath({ name: 'localdestinations-dryslopes'})") {{$t('page.localdestinations:nav.outdoor')}}
					li
						nuxt-link(:to="localePath({ name: 'localdestinations-revolvingslopes'})") {{$t('page.localdestinations:nav.indoor')}}
		div
			h1 {{contentpage.name}}
			ws-content(:value="filterstring? {markdown: ''} : contentpage.content")
			v-container.pa-0
				v-row.hidden-xs-only(no-gutters)
					v-col.font-weight-bold.text-no-wrap {{$tc('area_list.total_{count}', total)}}
					v-spacer
					areas-sort(v-model="sort")
						li(field="RELEVANCE") {{$t('area_list.sorting.relevance')}}
						li(field="NAME" ascending) {{$t('area_list.sorting.name')}}
						li(field="PISTES") {{$t('area_list.sorting.pistes')}}
						li(field="SNOW") {{$t('area_list.sorting.snow')}}
						li(field="MAXELEVATION") {{$t('area_list.sorting.maxelevation')}}
						//- li(field="RATING") {{$t('area_list.sorting.rating')}}
						li(:field="`DISTANCE_${$store.getters.preferedCity.toUpperCase()}`" ascending) {{$t('area_list.sorting.distance_{city}', {city: $store.getters.preferedCity.charAt(0).toUpperCase() + $store.getters.preferedCity.slice(1)})}}
			v-divider
			areas-map(:filterstring="filterstring" v-if="showMap")
			areas-list(:filterstring="filterstring" :sort="sort" :total.sync="total")
</template>

<script>
import gql from 'graphql-tag';
import Content from '@dengl/common/components/content.vue';
import AreasList from '@/components/areas/list.vue';
import AreasMap from '@/components/areas/map.vue';
import AreasSort from '@/components/areas/sort';
import AreasFilterList from '@/components/areas/filter-list.vue';
import NavigationDefaultList from '@/components/navigation-default-list';

import MetaFragment from '@/components/graphql/metaFragment.graphql';
const areasIndexQuery = gql`
	query getAreasIndexWithPath($path: String!) {
		contentpage(path: $path) {
			id
			name
			slug
			content {
				...ContentDataFragment
			}
			...MetaFragment
		}
	}
	${MetaFragment}
	${Content.fragments}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/skigebieden',
			'de-DE': '/skigebiete',
			'nl-BE': '/skigebieden'
		}
	},
	components: {
		AreasList,
		AreasMap,
		AreasSort,
		'areas-filter-list': AreasFilterList,
		NavigationDefaultList
	},
	asyncData({ app, error, route }) {
		app.ads({ navigation: { visible: true, type: 'spot' } });
		return app.$graphClient
			.query({
				query: areasIndexQuery,
				variables: {
					path: route.path
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (errors) {
					throw errors[0];
				}
				if (!data.contentpage) {
					return error({ statusCode: 404, message: 'Page not found' });
				}

				app.meta(data.contentpage.meta);

				app.breadcrumbs({
					[data.contentpage.name]: {
						name: 'contentpage',
						params: { 0: route.path.slice(1) }
					}
				});

				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'areas-index-01', error);
			});
	},
	data() {
		return {
			filterstring: '',
			sort: {
				ascending: false,
				field: 'RELEVANCE'
			},
			showMap: false,
			total: null
		};
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	watch: {
		'$route.hash'() {
			this.filterstringFromHash();
		},
		filterstring(val) {
			window.location.hash = `#${val}`;
		}
	},
	mounted() {
		this.filterstringFromHash();
	},
	methods: {
		filterstringFromHash() {
			if (this.$route.hash) {
				this.filterstring = this.$route.hash.slice(1);
			}
		}
	}
};
</script>
